module.exports = __webpack_public_path__ + "static/img/about-header.e27a816.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/about-header.jpg
// module id = j8xU
// module chunks = 0